"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var auth_config_1 = require("../config/auth.config");
exports.default = (function () {
    localStorage.removeItem(auth_config_1.authConfig.tokenStorageKey);
});
